<!-- AutoPublishSettings.vue -->
<template>
	<div class="auto-publish">
		<!-- Заголовок -->
		<h3 class="auto-publish__title">Автопубликация</h3>

		<!-- Контейнер с опциями и полями -->
		<div class="auto-publish__container">
			<!-- Опции выбора -->
			<div class="auto-publish__options">
				<!-- Опция "Сразу" -->
				<button
					class="auto-publish__option"
					:class="{ 'auto-publish__option--active': !isScheduled }"
					type="button"
					@click="selectOption(false)"
				>
					<div
						class="auto-publish__radio"
						:class="{ 'auto-publish__radio--active': !isScheduled }"
					></div>
					<div class="auto-publish__option-content">
						<span class="auto-publish__option-title">Сразу</span>
						<span class="auto-publish__option-description">
							Элемент опубликуется студентам сразу после создания.
						</span>
					</div>
				</button>

				<!-- Опция "По расписанию" -->
				<button
					class="auto-publish__option"
					:class="{ 'auto-publish__option--active': isScheduled }"
					type="button"
					@click="selectOption(true)"
				>
					<div
						class="auto-publish__radio"
						:class="{ 'auto-publish__radio--active': isScheduled }"
					></div>
					<div class="auto-publish__option-content">
						<span class="auto-publish__option-title">По расписанию</span>
						<span class="auto-publish__option-description">
							Задайте дату и время для публикации.
						</span>
					</div>
				</button>
			</div>

			<!-- Поля ввода даты и времени -->
			<div class="auto-publish__inputs">
				<!-- Дата публикации -->
				<div class="auto-publish__field">
					<label class="auto-publish__label">Дата публикации</label>
					<input
						type="date"
						:value="publishDate"
						@input="$emit('update:date', $event.target.value)"
						:disabled="!isScheduled"
						class="auto-publish__input"
						:class="{ 'auto-publish__input--disabled': !isScheduled }"
					/>
				</div>

				<!-- Время публикации -->
				<div class="auto-publish__field">
					<label class="auto-publish__label">Время публикации</label>
					<input
						type="time"
						:value="publishTime"
						@input="$emit('update:time', $event.target.value)"
						:disabled="!isScheduled"
						class="auto-publish__input"
						:class="{ 'auto-publish__input--disabled': !isScheduled }"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AutoPublishSettings',
	props: {
		isScheduled: {
			type: Boolean,
			default: false,
		},
		publishDate: {
			type: String,
			default: '',
		},
		publishTime: {
			type: String,
			default: '',
		},
	},
	emits: ['update:is-scheduled', 'update:date', 'update:time'],
	methods: {
		selectOption(scheduled) {
			this.$emit('update:is-scheduled', scheduled)
		},
	},
}
</script>

<style scoped>
.auto-publish {
	width: 100%;
	margin-bottom: 20px;
}

.auto-publish__title {
	color: #4b5563;
	font-family: 'Poppins', Helvetica;
	font-size: 17px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: normal;
	margin: 0 0 15px 0;
}

.auto-publish__container {
	background-color: #ffffff;
	border-radius: 10px;
	padding: 20px;
	display: flex;
	gap: 30px;
	align-items: flex-start;
}

/* Опции выбора */
.auto-publish__options {
	display: flex;
	flex-direction: column;
	gap: 15px;
	flex: 1;
	max-width: 400px;
}

.auto-publish__option {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	background: transparent;
	border: none;
	cursor: pointer;
	padding: 0;
	text-align: left;
	transition: opacity 0.2s ease;
}

.auto-publish__option:hover {
	opacity: 0.8;
}

.auto-publish__radio {
	background-color: #ffffff;
	border: 1px solid #000000;
	border-radius: 50%;
	height: 16px;
	min-width: 16px;
	width: 16px;
	margin-top: 4px;
	transition: all 0.2s ease;
}

.auto-publish__radio--active {
	background-color: #0095ec;
	border-color: #0095ec;
}

.auto-publish__option-content {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.auto-publish__option-title {
	color: #4b5563;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 500;
	letter-spacing: 0.2px;
	line-height: 1.3;
}

.auto-publish__option-description {
	color: #4b55638e;
	font-family: 'Poppins', Helvetica;
	font-size: 12px;
	font-weight: 400;
	letter-spacing: 0.1px;
	line-height: 1.4;
}

.auto-publish__option--active .auto-publish__option-description {
	color: #4b5563;
}

/* Поля ввода */
.auto-publish__inputs {
	display: flex;
	flex-direction: column;
	gap: 15px;
	flex: 1;
	max-width: 500px;
}

.auto-publish__field {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.auto-publish__label {
	color: #4b5563;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 400;
	letter-spacing: 0;
	line-height: normal;
}

.auto-publish__input {
	background-color: #ffffff;
	border: 0.5px solid #000000;
	border-radius: 10px;
	height: 50px;
	width: 100%;
	padding: 0 20px;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 500;
	color: #4b5563;
	outline: none;
	transition: border-color 0.2s ease, opacity 0.2s ease,
		background-color 0.2s ease;
}

.auto-publish__input:focus:not(:disabled) {
	border-color: #0095ec;
	box-shadow: 0 0 0 2px rgba(0, 149, 236, 0.1);
}

.auto-publish__input--disabled {
	opacity: 0.5;
	cursor: not-allowed;
	background-color: #f5f5f5;
}

/* Адаптивность */
@media (max-width: 768px) {
	.auto-publish__container {
		flex-direction: column;
	}

	.auto-publish__options,
	.auto-publish__inputs {
		max-width: 100%;
	}
}
</style>
